import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { message, Row } from 'antd';

import { SubHeader } from '../../components/SubHeader';
import * as S from './styles';

import {
  postINovoAtendimento,
  postIniciarAtendimentoExterno,
} from '../../services';

import { FinalService } from './FinalService.js';
import { TimeStamp } from './TimeStamp';

export function AtendimentoFinalizado() {
  document.title = 'TMOV GR';
  const history = useHistory();
  const [seconds, setSeconds] = useState(5);

  const iniciarAtendimentoInterno = async () => {
    try {
      const { data } = await postINovoAtendimento();
      if (data) {
        return await history.push('/atendimento');
      }
    } catch (error) {
      message.error(
        error?.response?.data?.detail || 'Não foi possível iniciar atentimento.'
      );
      return history.push('/painel-de-controle');
    }
  };

  const iniciarAtendimentoExterno = async () => {
    const { data, error } = await postIniciarAtendimentoExterno();

    if (data) {
      history.push('/atendimento');
      return;
    }

    if (error) {
      message.error('Não foi possível iniciar um atendimento');
      return history.push('/consultas-externas-painel');
    }
  };

  useEffect(() => {
    timer();
  });

  const timer = () => (
      seconds >= 1 &&
      setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000)
    );

  useMemo(async () => {
    const origem = history?.location?.state?.origem === 'externa';
    if (seconds === 0) {
      return origem
        ? await iniciarAtendimentoExterno()
        : await iniciarAtendimentoInterno();
    }
  }, [seconds, history, iniciarAtendimentoExterno, iniciarAtendimentoInterno]);

  const redirectClick = () => history?.location?.state?.origem === 'externa'
      ? history.push('/consultas-externas-painel')
      : history.push('/painel-de-controle');

  return (
    <S.Wrapper>
      <Row span={24}>
        <SubHeader />
      </Row>
      <S.Container>
        <S.Content>
          {seconds > 7 ? (
            <FinalService />
          ) : (
            <TimeStamp redirectClick={redirectClick} seconds={seconds} />
          )}
        </S.Content>
      </S.Container>
    </S.Wrapper>
  );
}
